export default __webpack_public_path__ + "8f624f5ce2a3c5426d40e3631bc28854.jpg";